/**
 * Sidebar favorites — pinned databases (saved views) and pages (composer nodes),
 * shown in a "Favorites" section at the top of the sidebar. Tracked per identity
 * in localStorage. Each entry: { type: 'database' | 'page', id, name }.
 * Emits `favorites-changed` on writes.
 */
const keyFor = (uid) => `sidebar_favorites_${uid || 'anon'}`;

export function getFavorites(uid) {
  try { return JSON.parse(localStorage.getItem(keyFor(uid)) || '[]'); } catch { return []; }
}

function save(uid, list) {
  try { localStorage.setItem(keyFor(uid), JSON.stringify(list)); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent('favorites-changed'));
}

const match = (f, type, id) => f.type === type && String(f.id) === String(id);

export function isFavorite(uid, type, id) {
  return getFavorites(uid).some(f => match(f, type, id));
}

export function toggleFavorite(uid, fav) {
  const list = getFavorites(uid);
  const exists = list.some(f => match(f, fav.type, fav.id));
  save(uid, exists
    ? list.filter(f => !match(f, fav.type, fav.id))
    : [...list, { type: fav.type, id: fav.id, name: fav.name }]);
}

export function removeFavorite(uid, type, id) {
  save(uid, getFavorites(uid).filter(f => !match(f, type, id)));
}
